import './MunViewer.scss';
import * as S from '../scss/theme';
import fnc from '../mymod/commFunction';
import HongButton from '../comm/HongButton';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import fncS4 from '../mymod/commFunction4';

const MunViewer = ({selectedItem, munSolDap}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [list, setList] = useState([]);
    const [imagePath, setImagePath] = useState('');
    const [error, setError] = useState(null);


  useEffect(() => {
  
          if (!selectedItem) {
              // setError('Selected list item not found.');
              return;
          }
  
          const fetchData = async () => {
             let imagePath = '';
              try {
                const imgUrl = process.env.REACT_APP_imgUrl_S3;//web/kuesbImageLms
                const acaCode = fnc.getCookie('s3_acaCode');//이거 확인 하도록

                if (!selectedItem.폴더) return; // 폴더가 없으면 함수 종료
                const folder = selectedItem.폴더?.replaceAll('\\', '/') ?? '';
                const imgFileName = selectedItem.이미지코드;

                if (munSolDap === 'mun') {
                    imagePath =  `${imgUrl}/${acaCode}/${folder}/${imgFileName}`;   
                } else if (munSolDap === 'sol') {
                  imagePath =  `${imgUrl}/${acaCode}/${folder}/풀이_${imgFileName}`;   
                }   

                         
                  const newImagePath = await fncS4.getS3Path(imagePath);
                  setImagePath(newImagePath);
                  
              } catch (error) {
                  console.error("Error fetching image path:", error);
                  setError("Failed to load image.");
              }
          };
  
          fetchData();
      }, [selectedItem, munSolDap]);

//=========================================
  return (

    <div className='MunViewer'>
       
        <section className='sec-image'>
            {imagePath ? (
                <img src={imagePath} alt="문항 이미지" />
            ) : (
                <p></p>
            )}          
        </section>
    </div>

  );
};

export default MunViewer;